const stripEmptyStrings = <T extends Record<string, unknown>>(obj: T): T =>
  Object.fromEntries(
    Object.entries(obj).map(([k, v]) => [k, v === "" ? undefined : v]),
  ) as T;

export default stripEmptyStrings;
